<script>
	// NPM Modules
	import dayjs from 'dayjs';
	import localizedFormat from 'dayjs/plugin/localizedFormat';
	// Services
	import { CurrencyFormat } from '@/Services/Helpers';
	import { UserRatingColours, UserSubRatingColours, UserRatingName, UserSubRatingName } from '@/Constants/User.js';

	dayjs.extend(localizedFormat);

	export let user;
</script>

<div class="flex flex-col md:w-1/2 text-dark-grey bg-gray-50 min-h-32 md:min-h-48">
	<div class="flex items-center justify-between px-4 py-2 bg-dark-grey text-light">
		<h2 class="text-xl italic font-sans-condensed">Projected Ratings</h2>
		<div class="flex items-center gap-2">
			<span class="text-sm italic text-light font-bold">Current Rating:</span>
			<span
				class="px-3 py-1 text-sm font-semibold rounded {UserRatingColours[user.rating.id].bg} {UserRatingColours[
					user.rating.id
				].text}">{UserRatingName[user.rating.id]}</span
			>
			{#if user.sub_rating?.id}
				<span
					class="px-3 py-1 text-sm font-semibold text-black rounded {UserSubRatingColours[user.sub_rating.id]
						.bg} {UserSubRatingColours[user.sub_rating.id].text}"
				>
					{UserSubRatingName[user.sub_rating.id]}
				</span>
			{/if}
		</div>
	</div>

	<div class="overflow-auto">
		<table class="table w-full text-sm text-left bg-white">
			<thead class="bg-grey text-light">
				<tr>
					<th class="py-2 px-4 w-1/4">Category</th>
					<th class="py-2 px-4 w-1/4">RNWPAD</th>
					<th class="py-2 px-4 italic w-1/4">Projected Rating</th>
					<th class="py-2 px-4 italic w-1/4">Projected Sub Rating</th>
				</tr>
			</thead>

			<tbody>
				{#if user.projected_ratings}
					{#each Object.entries(user.projected_ratings) as [key, value]}
						{#if key !== 'user_win_percentage'}
							<tr class="bg-gray-100 border-b">
								<td class="py-2 px-4 font-semibold whitespace-nowrap">
									{key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
								</td>

								<td class="py-2 px-4 font-semibold whitespace-nowrap">
									{user.projection_values && user.projection_values[key] != null && user.projection_values[key] !== ''
										? CurrencyFormat(user.projection_values[key])
										: '-'}
								</td>

								<td class="py-2 px-4">
									<span
										class="px-3 py-1 rounded text-xs font-semibold text-center {UserRatingColours[value]
											.bg} {UserRatingColours[value].text}"
									>
										{UserRatingName[value]}
									</span>
								</td>

								<td class="py-2 px-4">
									{#if user.projected_sub_ratings && key in user.projected_sub_ratings}
										<span
											class="px-3 py-1 rounded text-xs font-semibold text-center
										{UserSubRatingColours[user.projected_sub_ratings[key]]?.bg}
										{UserSubRatingColours[user.projected_sub_ratings[key]]?.text}"
										>
											{UserSubRatingName[user.projected_sub_ratings[key]]}
										</span>
									{/if}
								</td>
							</tr>
						{/if}
					{/each}
				{/if}
			</tbody>
		</table>
	</div>
</div>
